module.exports = __webpack_public_path__ + "static/media/seminar_program_10.067a12b0.pdf";